export enum AppComponents {
  DocumentFindDlg = 'DocumentFindDlg'
}

export class ComponentsStorage {
  [componentName: string]: {};
}
